import { withDependencies } from '@wix/thunderbolt-ioc'
import type { BrowserWindow, IAppDidMountHandler, Experiments, BusinessLogger } from '@wix/thunderbolt-symbols'
import { BrowserWindowSymbol, ExperimentsSymbol, BusinessLoggerSymbol } from '@wix/thunderbolt-symbols'
import { accessibilityUtils } from './accessibilityUtils'

const accessibilitySiteFactory = (
	window: BrowserWindow,
	experiments: Experiments,
	businessLogger: BusinessLogger
): IAppDidMountHandler => {
	return {
		appDidMount() {
			const fixBrowserZoomForSPX = experiments['specs.thunderbolt.browserZoomForSPX']
			const biForBrowserZoom = experiments['specs.thunderbolt.biForBrowserZoom']
			const { addBrowserZoomForSPX, addBiForBrowserZoom } = accessibilityUtils(window, experiments, businessLogger)
			if (fixBrowserZoomForSPX) {
				const userAgent = window!.navigator.userAgent
				const isMobile = /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
				// Safari 18.5 natively supports zooming for viewport units, so we don't need to add the browser zoom for SPX
				if (userAgent.includes('Chrome') || isMobile) {
					addBrowserZoomForSPX()
				}
			}

			if (biForBrowserZoom) {
				addBiForBrowserZoom()
			}
		},
	}
}

export const AccessibilitySite = withDependencies(
	[BrowserWindowSymbol, ExperimentsSymbol, BusinessLoggerSymbol] as const,
	accessibilitySiteFactory
)
